<app-hr-report-overview *ngIf="page=='overview'"></app-hr-report-overview>
<app-graduation *ngIf="page=='detail'"></app-graduation>



// WEBPACK FOOTER //
// ./src/app/hr-report.component.html